module.exports = __webpack_public_path__ + "img/L1020139-1600.56c8a9e3.webp";